import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { Stack, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import InlineItemsList from "@entrilia/shared/components/InlineItemsList";
import RoundedTable from "@entrilia/shared/components/RoundedTable";
import UserWithAvatar from "@entrilia/shared/components/UserWithAvatar";
import type { MemberExistingContact } from "../../../../../api/types/workflowTypes";
import useClientContext from "../../../../../context/useClientContext";
import { getObjectPageRoute } from "../../../../../utilities/navigationHelper";
import { getOtherMembershipsLabel } from "./membersChangeRequestHelper";

interface Props {
  contact: MemberExistingContact;
}

const ExistingContactWidget = ({ contact }: Props) => {
  const { clientCode, hasAnyPermission } = useClientContext();

  const hasAccessToFundStructure = hasAnyPermission(["ViewFundStructure", "ManageFundStructure"]);

  return (
    <Stack spacing={1}>
      <RoundedTable withoutColumnBorders>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "30%" }}>Name</TableCell>
            <TableCell sx={{ width: "20%" }}>Investors</TableCell>
            <TableCell sx={{ width: "30%" }}>Funds</TableCell>
            <TableCell sx={{ width: "20%", whiteSpace: "nowrap" }}>Access to Portal</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <UserWithAvatar
                userName={contact.name}
                userNameHref={
                  hasAccessToFundStructure ? getObjectPageRoute(clientCode, contact.contactId, "Contact") : undefined
                }
                email={contact.email}
                avatarSize="small"
                userNameVariant="subtitle2"
              />
            </TableCell>
            <TableCell>
              <InlineItemsList
                items={contact.investors}
                propGetter={(investor) => investor.investorName}
                popupTitle="Investors"
              />
            </TableCell>
            <TableCell>
              <InlineItemsList items={contact.funds} propGetter={(fund) => fund.fundName} popupTitle="Funds" />
            </TableCell>
            <TableCell>{contact.hasPortalAccess && <CheckRoundedIcon color="primary" />}</TableCell>
          </TableRow>
        </TableBody>
      </RoundedTable>
      {contact.otherMembershipsCount > 0 && (
        <Typography variant="caption" color="textSecondary">
          {getOtherMembershipsLabel(contact.otherMembershipsCount)}
        </Typography>
      )}
    </Stack>
  );
};

export default ExistingContactWidget;
